module.exports = __webpack_public_path__ + "static/bg-checkout-rtm-8d6f694ee5a0b7020dc434b810911d07.jpg";